export const colors={
  "white":"rgb(255, 255, 255)",
  "red":"rgb(252, 228, 228)",
  "green":"rgb(228, 244, 212)",
  "gray":"#d0d0d0",
  "yellow":"#fdda24"
}
